var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h1", [_vm._v(_vm._s(_vm.$t("userSubstitute.title")))]),
      _c("delegation-substitutes-menu"),
      _c(
        "v-row",
        { staticStyle: { "margin-bottom": "15px" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "3" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.$t("global.search"),
                  "append-icon": "search",
                  "hide-details": "",
                  "single-line": ""
                },
                model: {
                  value: _vm.search,
                  callback: function($$v) {
                    _vm.search = $$v
                  },
                  expression: "search"
                }
              })
            ],
            1
          ),
          _c("v-spacer"),
          _c(
            "div",
            [
              _c(
                "user-substitute-form",
                { on: { saved: _vm.load } },
                [
                  _c("v-btn", { attrs: { block: "", color: "accent" } }, [
                    _vm._v(_vm._s(_vm.$t("userSubstitute.addNew")))
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("v-data-table", {
        attrs: {
          headers: _vm.headers,
          items: _vm.substitutes,
          search: _vm.search,
          loading: _vm.$store.getters["Ajax/loading"] ? "accent" : false
        },
        scopedSlots: _vm._u([
          {
            key: "item",
            fn: function(props) {
              return [
                _c("tr", [
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(_vm._s(props.item.absent_user_name))
                  ]),
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(_vm._s(props.item.substitute_user_name))
                  ]),
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          props.item.from_date == null
                            ? _vm.$t("global.noSetTime")
                            : props.item.from_date
                        ) +
                        " "
                    )
                  ]),
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          props.item.to_date == null
                            ? _vm.$t("global.noSetTime")
                            : props.item.to_date
                        ) +
                        " "
                    )
                  ]),
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(_vm._s(props.item.comment))
                  ]),
                  _c(
                    "td",
                    { staticClass: "text-center px-0 text-no-wrap" },
                    [
                      _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    props.item.can_login_as
                                      ? _c(
                                          "v-btn",
                                          _vm._g(
                                            {
                                              staticClass: "mx-0",
                                              attrs: { icon: "" },
                                              on: {
                                                click: function($event) {
                                                  return _vm.loginAs(props.item)
                                                }
                                              }
                                            },
                                            on
                                          ),
                                          [
                                            _c(
                                              "v-icon",
                                              { attrs: { color: "" } },
                                              [
                                                _vm._v(
                                                  "transfer_within_a_station"
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("userSubstitute.logAsAbsentUser")) +
                              " "
                          )
                        ]
                      ),
                      props.item.can_modify
                        ? _c("user-substitute-form", {
                            attrs: { userSubstitute: props.item },
                            on: {
                              "update:userSubstitute": function($event) {
                                return _vm.$set(props, "item", $event)
                              },
                              "update:user-substitute": function($event) {
                                return _vm.$set(props, "item", $event)
                              },
                              saved: _vm.load
                            }
                          })
                        : _vm._e(),
                      _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    props.item.can_modify
                                      ? _c(
                                          "v-btn",
                                          _vm._g(
                                            {
                                              attrs: { icon: "" },
                                              nativeOn: {
                                                click: function($event) {
                                                  return _vm.remove(props.item)
                                                }
                                              }
                                            },
                                            on
                                          ),
                                          [_c("v-icon", [_vm._v("delete")])],
                                          1
                                        )
                                      : _vm._e()
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("global.delete")) + " ")]
                      )
                    ],
                    1
                  )
                ])
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }